import {CSSProperties, useEffect, useRef} from 'react';
import Loading from '../component/Loading';
import TextButton, {IProps as ITextButtonProps} from '../component/TextButton';
import {useFetchInfo} from '../util/fetch';

export interface IProps
  extends Omit<ITextButtonProps, 'height' | 'style' | 'ref'> {
  height?: string;
  actionType: string;
  fetchKey?: string | number;
  style?: Omit<CSSProperties, 'height'>;
  showLoading?: boolean;
}

export default function FetchTextButton({
  width,
  actionType,
  fetchKey,
  children,
  showLoading = false,
  ...rest
}: IProps) {
  const {isSlow} = useFetchInfo(actionType, fetchKey);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const prevWidth = useRef(width || '0px');
  useEffect(() => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      prevWidth.current = `${rect.width}px`;
    }
  });
  return (
    <>
      {(isSlow || showLoading) && (
        <TextButton width={width || prevWidth.current} {...rest}>
          <Loading />
        </TextButton>
      )}
      {!isSlow && !showLoading && (
        <TextButton ref={buttonRef} width={width} {...rest}>
          {children}
        </TextButton>
      )}
    </>
  );
}
